import I18n from 'I18n';
import ActionButtonComponent from '../ActionButtonComponent';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { ReplyIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ReplyButton = ({
  collapsed,
  genericChannelId,
  onClick
}) => {
  const onButtonClick = e => {
    onClick(e);
    usageTracker.track('message-reply', {
      action: 'message reply',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    onClick: onButtonClick,
    collapsed: collapsed,
    buttonIcon: ReplyIcon,
    "data-test-id": 'reply-button',
    i18nButtonText: I18n.text('conversations-inbox-message-history.email.reply')
  });
};
ReplyButton.displayName = 'ReplyButton';
export default ReplyButton;